import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";
import GetAppIcon from "@material-ui/icons/GetApp";
import SearchIcon from "@material-ui/icons/Search";
import CommentIcon from "@mui/icons-material/Comment";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import SnackbarAlert from "./SnackbarAlert";
import DialogComentariosPanel from "./DialogComentariosPanel";
import DialogDetallePanelGeneral from "./DialogDetallePanelGeneral";
import { inventarioResources } from "../endpoints";
import useToken from "../useToken";
import { Tooltip } from "@mui/material";

class TablaPanelGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: useToken.getUser(),
      openSnack: false,
      message: null,
      severity: null,
      openComentarios: false,
      comentarios: null,
      rowData: null,
      openDatosAdicionales: false,
      selectedRow: null
    };
  }

  verificaAvanceCosto(rowData) {
    if (rowData.teoimp === 0) {
      return (0).toFixed(2);
    }

    return ((rowData.invimp / rowData.teoimp) * 100).toFixed(2);
  }

  verDatosAdicionales(rowData) {
    this.setState({
      openDatosAdicionales: true,
      rowData
    });
  }

  abrirComentarios(comentarios) {
    this.setState({
      openComentarios: true,
      comentarios
    });
  }

  cerrarComentarios = () => {
    this.setState({
      openComentarios: false,
      openDatosAdicionales: false,
    });
  };

  refrescar = (estado, severity) => {
    this.setState({
      openSnack: false,
    }, ()=>{
        if (severity) {
            this.setState({
                openSnack: true,
                message: estado,
                severity: severity
            });
        }
    });
  };

  getArchivosCargados = (rowData) => {

    inventarioResources
      .verificaArchivosImportados(rowData.folio)
      .then(async (response) => await response.json())
      .then((data) => {

        if (data) {

          const link = document.createElement("a");
          link.href = `/static/spool/inv_${rowData.folio}/archivos_importados_${rowData.folio}.zip`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

        } else {
            this.setState({
                openSnack:false
                },()=>{
                this.setState({
                    openSnack: true,
                    message: "Nada para descargar",
                    severity: "error"
                });
            })
        }
      });
  };

  getArchivoResultado = (rowData) => {

    let schema = "inv_" + rowData.folio;

    inventarioResources
      .getRutaArchivosFinales(rowData.folio)
      .then(async (response) => await response.json())
      .then((data) => {

        if (data.length > 0) {

          const link = document.createElement("a");
          let ruta = `/spool/${schema}/exportaciones/${data[0]}`;

          link.href = `/static${ruta}`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

        } else {
             this.setState({
                openSnack:false
                },()=>{
                this.setState({
                    openSnack: true,
                    severity: "error",
                    message: "No hay archivos para descargar"
                });
            })
        }
      });
  };

  render() {

    const columns = [
        {
            field: "folio",
            headerName: "Folio",
            minWidth: 90,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
        },

        {
            field: "fecha",
            headerName: "Fecha",
            minWidth: 110,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            valueGetter: (params) =>
            params.row.fecha.split("-").reverse().join("/")
        },

        {
            field: "cliente",
            headerName: "Cliente",
            minWidth: 100,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            valueGetter: (params) =>
            params.row.cliente
                ?.toLowerCase()
                .replace(/\b\w/g, (l) => l.toUpperCase()),
            renderCell: (params) => (
                <div style={{
                whiteSpace: "normal",
                lineHeight: "1.3"
                }}>
                {params.value}
                </div>
            )  
        },

        {
            field: "tienda",
            headerName: "Tienda",
            minWidth: 140,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            renderCell: (params) => (
                <div style={{
                whiteSpace: "normal",
                lineHeight: "1.3",
                fontSize: "0.8rem" 
                }}>
                {params.value}
                </div>
            )  
        },

        {
            field: "avance",
            headerName: "Avance (%)",
            minWidth: 150,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            renderCell: (params) => {
                if (params.value == null) return null;

                const value = params.value * 100;

                let color = "error"; // rojo
                if (value === 100) color = "success";
                else if (value > 50) color = "warning";

                return (
                <div style={{ width: "100%" }}>
                    <div style={{ fontSize: 12, fontWeight: 600 }}>
                    {value.toFixed(2)}%
                    </div>

                    <LinearProgress
                    variant="determinate"
                    value={value}
                    color={color}
                    sx={{
                        height: 8,
                        borderRadius: 4
                    }}
                    />
                </div>
                );
            }
        },

        {
            field: "avanceCosto",
            headerName: "Avance Costo(%)",
            minWidth: 140,
            flex: 1,
            sortable: false,
            valueGetter: (params) =>
            this.verificaAvanceCosto(params.row) + "%"
        },

        {
            field: "inv",
            headerName: "Inv.",
            minWidth: 120,
            flex:1,
            sortingOrder: ['asc', 'desc'],
            valueGetter: (params) =>
            new Intl.NumberFormat("de-DE").format(params.row.inv)
        },

        {
            field: "teo",
            headerName: "Teo.",
            minWidth: 120,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            valueGetter: (params) =>
            new Intl.NumberFormat("de-DE").format(params.row.teo)
        },

        {
            field: "dif",
            headerName: "Dif.",
            minWidth: 120,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            valueGetter: (params) =>
            new Intl.NumberFormat("de-DE").format(params.row.dif)
        },

        {
            field: "invimp",
            headerName: "Inv.Costo",
            minWidth: 130,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            valueGetter: (params) =>
            new Intl.NumberFormat("de-DE").format(params.row.invimp)
        },

        {
            field: "teoimp",
            headerName: "Teo.Costo",
            minWidth: 130,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            valueGetter: (params) =>
            new Intl.NumberFormat("de-DE").format(params.row.teoimp)
        },

        {
            field: "difimp",
            headerName: "Dif.Costo",
            minWidth: 130,
            flex:1,
            sortingOrder: ['asc', 'desc'],
            valueGetter: (params) =>
            new Intl.NumberFormat("de-DE").format(params.row.difimp)
        },

        {
            field: "operadores",
            headerName: "Operadores",
            minWidth: 120,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            valueGetter: (params) =>
            new Intl.NumberFormat("de-DE").format(params.row.operadores)
        },

        {
            field: "estado",
            headerName: "Estado",
            minWidth: 100,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            valueGetter: (params) =>
            params.row.estado
                ?.toLowerCase()
                .replace(/\b\w/g, (l) => l.toUpperCase())
        },

        {
            field: "acciones",
            headerName: "Acciones",
            minWidth: 150,
            flex: 1,
            sortable: false,
            renderCell: (params) => {

            const rowData = params.row;

            return (

                <div style={{ display: "flex", gap: 8 }}>
                
                <Tooltip title="Descargar archivos finales">
                    <GetAppIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => this.getArchivoResultado(rowData)}
                    />
                </Tooltip>
             
                <Tooltip title="Ver comentarios">
                    <CommentIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => this.abrirComentarios(rowData.comentarios)}
                    />
                </Tooltip>

                <Tooltip title="Ver datos adicionales">
                    <SearchIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => this.verDatosAdicionales(rowData)}
                    />
                </Tooltip>

                </div>

            );
            }
        }

    ];

    return (
    <div style={{ height: "calc(100vh - 150px)", width: "100%" }}>
        <DataGrid
            rows={this.props.disponibles}
            rowCount={this.props.totalRecords}
            loading={this.props.loading}
            disableColumnMenu
            columns={columns}
            getRowId={(row) => row.folio}
            paginationMode="server"
            sortingMode="server"
            pageSizeOptions={[10, 25, 50, 100]}
            paginationModel={{
                page: this.props.page,
                pageSize: this.props.pageSize
            }}
            onPaginationModelChange={(model) => {
                this.props.onPageChange(model.page, model.pageSize);
            }}
            onSortModelChange={(sortModel) => {
                const field = sortModel[0]?.field || "fecha";
                const dir = sortModel[0]?.sort || "desc";
                this.props.onSortChange(field, dir);
            }}

            onRowClick={(params) => this.setState({ selectedRow: params.id })}
            localeText={{
                noRowsLabel: "No hay datos para mostrar"
            }}
        />

        {this.state.openSnack && (
            <SnackbarAlert
                severity={this.state.severity}
                message={this.state.message}
            />
        )}

        {this.state.openComentarios && (
            <DialogComentariosPanel
                comentarios={this.state.comentarios}
                handleClose={this.cerrarComentarios}
            />
        )}

        {this.state.openDatosAdicionales && (
            <DialogDetallePanelGeneral
                rowData={this.state.rowData}
                handleClose={this.cerrarComentarios}
            />
        )}
        
        <style>
        {`
            .fila-verde {
            background-color: #81c784;
            }

            .fila-amarilla {
            background-color: #ffd54f;
            }

            .fila-roja {
            background-color: #e57373;
            }
        `}
        </style>
      </div>

    );
  }
}

export default TablaPanelGeneral;